import React, { useState, useEffect } from "react";
import { Button, Space } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "shared/redux/store";
interface CreditSaisonRejected {
  data: any;
  responseJSONSchema: any;
  selectedLander: any;
  leadData: any;
  handleFormSubmit: any;
  setCloseConfirmation: any;
  errorMessage:any;
  redirectpage:any
}
const CreditSaisonRejected: React.FunctionComponent<CreditSaisonRejected> = ({
  data,
  responseJSONSchema,
  selectedLander,
  leadData,
  handleFormSubmit,
  setCloseConfirmation,
  errorMessage,
  redirectpage 
}) => {

  const {appColors}: any = useSelector((state: RootState) => state.common);

  const handleSubmitReq = () => {
    handleFormSubmit({ data: {} })
  }
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: 'center',
        flexDirection: "column",
        height: "250px",
      }}
    >
      <div
        style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: 'column',
            fontSize: "1.2rem",
            alignItems: "center",
        }}
      >
        <div style={{ fontSize: '24px', fontWeight: '350' }}>{errorMessage}</div>
        <div style={{ fontSize: '24px', fontWeight: '350' }}></div>
      </div>
      {/* buttons */}
      <div
        style={{
          display: "flex",
          justifyContent: "right",
          marginBlock: "10px",
        }}
      >
        <Space className="">
          <Button
            htmlType="button"
            className="dynamic-btn-default"
            style={{
              '--borderColor': appColors?.appSecondaryColor ?? "",
              width: '155px',
              height: '52px',
              borderRadius: '10px'
            } as any}
            onClick={() => { redirectpage()
              setCloseConfirmation(true);
            }}
          >
            Close
          </Button>
        </Space>
      </div>
    </div>
  );
};

export default CreditSaisonRejected;
